const TRANSLATIONS = {
    en: {
        cancel: "I've changed my mind",
        continue: 'I Understand',
        instructions: `If you create a new board you will permanently lose all unsaved work.`,
        success: 'Starting a new board...',
        warning: 'Just double checking!'
    }
}

export default TRANSLATIONS